import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogTitle, DialogContent, Icon } from '@mui/material'
import { IColuna } from 'app/types/IColuna'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { PaperArrastavel } from '../../../dialog-arrastavel/PaperArrastavel'

const estiloTabela = require('../../../../estilos/tabelas.module.scss').default


export type AcoesHeadProps = {
    nomeGrid: string
    onAlterarFonte?: (tamanho: number) => void
    colunas: IColuna[],
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
    tamanhoFonte: number
    permiteEngrenagemGrid: boolean
}

export const AcoesHeadDocumentosQuitados = React.memo((props: AcoesHeadProps) => {
    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')

    const selecaoDeColunas = 
        <div className="_grid _grid-cols-1 _grid-flow-row">
            <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
                <div className="_mr-4">
                    <input
                        type="checkbox"
                        checked={props.colunas.every(c => c.Selecionada == true)}
                        onChange={e => props.onToggleSelecionarTodasColunas(e.target.checked)} />
                </div>
                <b>Todas</b>

            </div>

            {props.colunas.map(coluna => <div
                className="_flex _flex-row _justify-start _max-w-xs _items-end"
                key={coluna.Nome}>

                <div className="_mr-4">
                    <input
                        type="checkbox"
                        checked={coluna.Selecionada ?? false}
                        onChange={() => props.onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)} />
                </div>

                {coluna.Nome}
            </div>)}
        </div>

    const selecaoDeColunasDialog =
        <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
            <DialogTitle>
                Selecionar colunas para exibição
            </DialogTitle>
            <DialogContent>
                {selecaoDeColunas}
            </DialogContent>
        </Dialog>

    const botoes = 
        <div className={clsx(["_flex _flex-row _mt-4 _gap-x-2", estiloTabela.acoesHead])}>

            {(props.permiteEngrenagemGrid ?? false) && <>
                <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" onClick={() => setExibirSelecaoDeColunas(true)} />
            </>}

            <button
                className={clsx('no-global-button', estiloTabela.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
                disabled={props.tamanhoFonte >= 26}
            >A+
            </button>
            <button
                className={clsx('no-global-button', estiloTabela.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
                disabled={props.tamanhoFonte <= 8}
            >A-
            </button>
        </div>

    const iconeExibirEsconderOpcoes = (
        <button
            style={{ marginLeft: '14px', height: '20px' }}
            id="table-head__grid-itens__arrow"
            className="no-global-button"
            onClick={() => {
                setMostrarFerramentas(!mostrarFerramentas);
                setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
            }}
        >
            <Icon>{icon}</Icon>
        </button>
    );

    return <div id="AcoesHeadDocumentosQuitados">
        <div className={estiloTabela.menu} style={{backgroundColor: "var(--mu-superficie-forte, #daddde)"}}>
            {iconeExibirEsconderOpcoes}
            {mostrarFerramentas && (
                <section>
                    {botoes}
                </section>
            )}
        </div>
        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </div>
})